import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {PeripheralCheckPage} from './peripheral-check';

@NgModule({
  declarations: [
    PeripheralCheckPage,
  ],
  imports: [
    IonicPageModule.forChild(PeripheralCheckPage),
  ],
  exports: [
    PeripheralCheckPage
  ]
})
export class PeripheralCheckPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/peripheral-check/peripheral-check.module.ts